import { incYenOf } from '../../../lib/pricing';
const coursesAdvanced = {
  // page.tsx JSON-LD
  'coursesAdvanced.jsonld.breadcrumb.home': 'ホーム',
  'coursesAdvanced.jsonld.breadcrumb.courses': 'コース紹介',
  'coursesAdvanced.jsonld.breadcrumb.current': 'アドバンスコース',
  'coursesAdvanced.jsonld.course.name': 'アドバンスコース',
  'coursesAdvanced.jsonld.course.description': 'エッセンシャルの内容を含み、ワイン・イベント運営・国際マナーまで、執事の専門技能を2ヶ月・72時間で磨き上げる中級課程。本物のサービスを体験する特別実習付き。全日本執事協会運営。',
  'coursesAdvanced.jsonld.provider': '一般社団法人全日本執事協会',
  'coursesAdvanced.lastUpdated': '最終更新: 2026年6月13日',
  'coursesAdvanced.backToTop': 'ページトップへ戻る',

  // HeroSection
  'coursesAdvanced.hero.homeLink': 'ホーム',
  'coursesAdvanced.hero.coursesLink': 'コース紹介',
  'coursesAdvanced.hero.currentPage': 'アドバンスコース',
  'coursesAdvanced.hero.title': 'アドバンスコース',
  'coursesAdvanced.hero.titleEn': 'ADVANCED COURSE',
  'coursesAdvanced.hero.lead': 'アドバンスコースは、エッセンシャルの内容を含んだ上で、ワイン・イベント運営・国際マナーまで執事の専門技能を2ヶ月・72時間で磨き上げる中級課程です。未経験からの直接受講も可能です。プロを目指す方向けの執事スクールとして、執事養成学校ならではの専門領域を実践的に学べます。',
  'coursesAdvanced.hero.imgAlt': '大階段の上に凛と立つ日本人男性執事 - アドバンスコース',
  'coursesAdvanced.hero.imgTitle': '日本執事アカデミー アドバンスコース',

  // HeroSection trust badges (index-based)
  'coursesAdvanced.badge.0': '定員6名の完全少人数制',
  'coursesAdvanced.badge.1': '本物のサービスを体験する特別実習つき',
  'coursesAdvanced.badge.2': '修了で協会認定資格',
  'coursesAdvanced.badge.3': 'エッセンシャルの全内容を含みます',

  // CourseOverview (same structure as essential)
  'coursesAdvanced.overview.label': 'COURSE OVERVIEW',
  'coursesAdvanced.overview.title': 'コース概要',
  'coursesAdvanced.overview.colItem': '項目',
  'coursesAdvanced.overview.colContent': '内容',
  'coursesAdvanced.overview.rowDuration': '期間',
  'coursesAdvanced.overview.rowDays': '開催日数',
  'coursesAdvanced.overview.rowHours': '総時間',
  'coursesAdvanced.overview.rowPrice': '受講料',
  'coursesAdvanced.overview.rowSchedule': '開校時期',
  'coursesAdvanced.overview.rowFormat': '授業形式',
  'coursesAdvanced.overview.rowCapacity': '定員',
  'coursesAdvanced.overview.rowTarget': '対象',
  'coursesAdvanced.overview.valueDuration': '2ヶ月',
  'coursesAdvanced.overview.valueDays': '12日間',
  'coursesAdvanced.overview.valueHours': '72時間',
  'coursesAdvanced.overview.valuePrice': incYenOf('ac-advanced'),
  'coursesAdvanced.overview.priceFormat': '¥{price}（税込）',
  'coursesAdvanced.overview.valueSchedule': '5〜6月・11〜12月開校',
  'coursesAdvanced.overview.valueFormat': '土日開催・1日6時間（90分×4コマ）',
  'coursesAdvanced.overview.valueCapacity': '完全少人数制（定員6名）',
  'coursesAdvanced.overview.valueTarget': '基礎知識がある方・スキルアップ希望者（未経験者も直接受講可）',
  'coursesAdvanced.overview.note': '※表示価格はすべて税込です。開校日程の詳細は',
  'coursesAdvanced.overview.scheduleLink': '年間スケジュール',
  'coursesAdvanced.overview.noteSuffix': 'をご確認ください。',

  // TargetAudience (index-based)
  'coursesAdvanced.target.label': 'WHO IS THIS FOR',
  'coursesAdvanced.target.title': 'こんな方におすすめ',
  'coursesAdvanced.target.lead': 'アドバンスコースはエッセンシャルの内容を含む中級課程のため、未経験の方も直接受講いただけます。中でも次のような方に特におすすめです',
  'coursesAdvanced.target.0': 'ホテル・レストラン等で働きながら専門性を高めたい方',
  'coursesAdvanced.target.1': 'エッセンシャルコース修了からステップアップする方',
  'coursesAdvanced.target.2': 'ワインや宴会運営の本格技能を求める方',
  'coursesAdvanced.target.3': '海外ゲスト対応力を身につけたい方',

  // LearningContent
  'coursesAdvanced.learning.label': 'CURRICULUM',
  'coursesAdvanced.learning.title': 'アドバンスコースで何が学べる？',
  'coursesAdvanced.learning.lead': 'エッセンシャルの内容を含み、ワインサービスから国際マナーまで、中級の専門技能6領域を実践的に習得します。執事養成に特化した日本の執事学校として、現場で通用する応用力を養います。',
  'coursesAdvanced.learning.imgAlt': 'アドバンスコース学習内容 - {title}の実習風景',
  'coursesAdvanced.learning.imgTitle': '日本執事アカデミー - {title}',
  'coursesAdvanced.learning.0.title': '高度なサービス技術',
  'coursesAdvanced.learning.0.titleEn': 'Advanced Service Techniques',
  'coursesAdvanced.learning.0.description': 'エッセンシャルで学んだ基本所作を、シルバーサービスや複数ゲストへの同時サービスにまで高めます。ロールプレイングでは実際の晩餐会を想定した緊張感ある場面を体験し、どのような状況でも滞りないサービスを提供できる技術を磨きます。',
  'coursesAdvanced.learning.1.title': 'ワインとスピリッツの知識',
  'coursesAdvanced.learning.1.titleEn': 'Wine & Spirits',
  'coursesAdvanced.learning.1.description': '主要産地と品種の基礎知識から、保管と温度管理、抜栓からデキャンタージュ、美しい注ぎ方までの実技を体系的に学びます。テイスティング演習では、生産地やヴィンテージの違いを実際に感じ取り、ゲストへの的確な提案力を養います。',
  'coursesAdvanced.learning.2.title': 'イベント計画と管理',
  'coursesAdvanced.learning.2.titleEn': 'Event Planning & Management',
  'coursesAdvanced.learning.2.description': '晩餐会・パーティーの企画立案から、進行表の作成、当日の指揮まで一連の流れを実践的に学びます。座学でフレームワークを理解した後、実際に小規模なイベントを企画・運営するプロジェクト演習を行い、現場で通用するマネジメント力を身につけます。',
  'coursesAdvanced.learning.3.title': 'テーブルセッティングの応用',
  'coursesAdvanced.learning.3.titleEn': 'Advanced Table Setting',
  'coursesAdvanced.learning.3.description': 'エッセンシャルで基礎を習得したテーブルセッティングを、フォーマルディナーのフルセッティングとテーマ別コーディネートへと発展させます。花や小物のあしらい、照明との調和まで考慮した空間演出の技術を習得し、あらゆる場面に対応できる応用力を養います。',
  'coursesAdvanced.learning.4.title': '国際的なマナーと文化理解',
  'coursesAdvanced.learning.4.titleEn': 'International Etiquette',
  'coursesAdvanced.learning.4.description': '国や宗教による食の禁忌や慣習、海外ゲストへの配慮の実例を学びます。模擬ディナーでは複数国籍のゲストを想定したシチュエーション演習を行い、文化的背景の違いを理解した上での適切なおもてなしを実践できる国際感覚を身につけます。',
  'coursesAdvanced.learning.5.title': '高級衣類のケア',
  'coursesAdvanced.learning.5.titleEn': 'Luxury Garment Care',
  'coursesAdvanced.learning.5.description': 'エッセンシャルで基礎を固めた衣類ケアを、スーツ・ドレス・革製品など素材別の高度な手入れへと発展させます。ウールやシルク、カシミヤ等のデリケートな素材に適した保管方法、トラブル発生時の応急処置まで、衣類資産を長く保護する専門技術を習得します。',

  // LearningProgression
  'coursesAdvanced.progression.label': 'LEARNING FLOW',
  'coursesAdvanced.progression.title': '学習の流れ',
  'coursesAdvanced.progression.lead': '2ヶ月・全12日間を通じて、エッセンシャルの内容を含めて段階的にステップアップします',
  'coursesAdvanced.progression.0.title': '1ヶ月目（前半6日間）: エッセンシャルの内容を総復習',
  'coursesAdvanced.progression.0.description': '基本マナーとエチケット・日常的な家事管理・基本的なテーブルセッティング・紅茶とコーヒーの淹れ方・衣類の手入れ・基本的なコミュニケーション技術を通して復習し、確かな土台を固めます。',
  'coursesAdvanced.progression.1.title': '2ヶ月目（後半6日間）: アドバンス専門領域へ発展',
  'coursesAdvanced.progression.1.description': '高度なサービス技術・ワインとスピリッツの知識・イベント計画と管理・テーブルセッティングの応用・国際的なマナーと文化理解・高級衣類のケアへと学びを広げます。',
  'coursesAdvanced.progression.note': '※未経験からご入学の方も、この順で無理なく学べます。エッセンシャルコース修了者は1ヶ月目を復習としてご活用いただけます。',

  // HotelTraining
  'coursesAdvanced.hotelTraining.label': 'FIELD TRAINING',
  'coursesAdvanced.hotelTraining.title': '本物のサービスを体験する特別実習',
  'coursesAdvanced.hotelTraining.titleEn': 'Real Service Experience',
  'coursesAdvanced.hotelTraining.description': '一流ホテルやレストランで提供される本格的なアフタヌーンティーやコース料理を、受講生がゲスト（お客様）として体験し、プロのサービスマンの所作・間合い・気配りを間近で観察して学びます。受け手の立場を知ることは、質の高いサービスを提供するうえで欠かせません。',
  'coursesAdvanced.hotelTraining.0.title': '体験先',
  'coursesAdvanced.hotelTraining.0.text': '体験先は内容に応じてご案内します',
  'coursesAdvanced.hotelTraining.1.title': '実施時間',
  'coursesAdvanced.hotelTraining.1.text': '半日（約4時間）・コース期間内の1日に設定',
  'coursesAdvanced.hotelTraining.2.title': '体験費用',
  'coursesAdvanced.hotelTraining.2.text': '体験にかかる費用の詳細はお申込み時にご案内します',
  'coursesAdvanced.hotelTraining.note': '※体験先までの交通費のみご負担ください。',

  // DailySchedule
  'coursesAdvanced.schedule.label': 'DAILY SCHEDULE',
  'coursesAdvanced.schedule.title': '1日の流れ',
  'coursesAdvanced.schedule.lead': '90分×4コマで構成される授業日（土曜または日曜）のタイムテーブル例です',
  'coursesAdvanced.schedule.note': '※上記は標準的なタイムテーブル例です。回により内容が前後する場合がございます。',
  'coursesAdvanced.schedule.0.time': '10:00 – 11:30',
  'coursesAdvanced.schedule.0.title': '理論講義',
  'coursesAdvanced.schedule.0.description': '各回のテーマに沿った座学。ワインやイベント運営の専門知識を体系的に学びます。',
  'coursesAdvanced.schedule.1.time': '11:45 – 13:15',
  'coursesAdvanced.schedule.1.title': '実技演習',
  'coursesAdvanced.schedule.1.description': '講師のデモンストレーションの後、受講生お一人ずつ実践。ワインの抜栓やテーブルセッティングを繰り返し練習します。',
  'coursesAdvanced.schedule.2.time': '13:15 – 14:00',
  'coursesAdvanced.schedule.2.title': '昼食休憩',
  'coursesAdvanced.schedule.2.description': '',
  'coursesAdvanced.schedule.3.time': '14:00 – 15:30',
  'coursesAdvanced.schedule.3.title': 'ロールプレイング実習',
  'coursesAdvanced.schedule.3.description': '複数ゲストを想定した高度なシチュエーション演習。晩餐会やパーティーのサービスを実践形式で体験します。',
  'coursesAdvanced.schedule.4.time': '15:45 – 17:15',
  'coursesAdvanced.schedule.4.title': '実技＋講評',
  'coursesAdvanced.schedule.4.description': '午前の実技の応用演習と、その日の学びを講師とともに振り返るレビューセッション。個別フィードバックを行います。',

  // CertificationSection
  'coursesAdvanced.cert.label': 'CERTIFICATION',
  'coursesAdvanced.cert.title': '修了実技試験と認定資格',
  'coursesAdvanced.cert.titleEn': 'Certified Professional Butler',
  'coursesAdvanced.cert.description': 'コース最終日に実施する修了実技試験（フォーマルディナーのセッティングとワインサービスの実演）に合格すると、以下の認定資格が授与されます。',
  'coursesAdvanced.cert.qualLabel': '取得資格',
  'coursesAdvanced.cert.qualification': '認定プロフェッショナルバトラー（Certified Professional Butler）',
  'coursesAdvanced.cert.badge': '認定ピンバッジ',
  'coursesAdvanced.cert.note': '※当資格は一般社団法人全日本執事協会が独自に認定する民間資格です。',

  // CourseBenefits
  'coursesAdvanced.benefits.label': 'BENEFITS',
  'coursesAdvanced.benefits.title': '受講特典',
  'coursesAdvanced.benefits.lead': 'アドバンスコース受講生の皆様に付帯する特典です',
  'coursesAdvanced.benefits.detailLink': '※特典の詳細は受講特典ページをご覧ください',
  'coursesAdvanced.benefits.0.title': '教科書セット（計10冊・E1〜E5+A1〜A5）',
  'coursesAdvanced.benefits.0.description': 'エッセンシャルのE群5冊に加え、家政管理・秘書業務・テーブルマナー・イベント企画・ライフスタイル管理のA群5冊を進呈。全日本執事協会監修。',
  'coursesAdvanced.benefits.1.title': 'ワインオープナーセット',
  'coursesAdvanced.benefits.1.description': 'ソムリエナイフとウェイターズコークスクリューをセットで進呈。実習および修了後もご使用いただけます。',
  'coursesAdvanced.benefits.2.title': '基本的な執事道具セット',
  'coursesAdvanced.benefits.2.description': 'プロ仕様の基本ツール一式を進呈します。',
  'coursesAdvanced.benefits.3.title': 'オリジナルエプロン',
  'coursesAdvanced.benefits.3.description': '実習時に着用するアカデミー特製のエプロン。',
  'coursesAdvanced.benefits.4.title': '白手袋（初日支給・実習で着用）',
  'coursesAdvanced.benefits.4.description': '高品質な白手袋。執事の象徴として、初日からサービス実習で着用します。',

  // NextStep
  'coursesAdvanced.nextStep.label': 'STEP-UP DISCOUNT',
  'coursesAdvanced.nextStep.fromEssential': 'エッセンシャル',
  'coursesAdvanced.nextStep.toAdvanced': 'アドバンス',
  'coursesAdvanced.nextStep.toMaster': 'マスター',
  'coursesAdvanced.nextStep.descriptionEssential': 'アドバンスコースはエッセンシャルの内容を含むため、エッセンシャルコース修了者が本コースへ進む場合、重複する内容分の受講料80,000円が減額されます。',
  'coursesAdvanced.nextStep.descriptionMaster': 'マスターコースはアドバンスの内容を含むため、本コース修了者がマスターコースへ進む場合、重複する内容分の受講料180,000円が減額されます。',
  'coursesAdvanced.nextStep.discountEssential': '80,000',
  'coursesAdvanced.nextStep.discountMaster': '180,000',
  'coursesAdvanced.nextStep.discountLabel': '減額: ¥{amount}',
  'coursesAdvanced.nextStep.viewEssential': 'エッセンシャルコースを見る',
  'coursesAdvanced.nextStep.viewMaster': 'マスターコースを見る',

  // AdmissionFlow
  'coursesAdvanced.admission.label': 'ADMISSION FLOW',
  'coursesAdvanced.admission.title': '受講までの流れ',
  'coursesAdvanced.admission.viewDetail': '詳細を見る',
  'coursesAdvanced.admission.0.titleEn': 'Brochure',
  'coursesAdvanced.admission.0.title': '資料請求',
  'coursesAdvanced.admission.0.description': 'まずは資料請求から。コースの詳細やアカデミーの理念をまとめた資料をお送りします。',
  'coursesAdvanced.admission.1.titleEn': 'Consultation',
  'coursesAdvanced.admission.1.title': '個別相談（任意）',
  'coursesAdvanced.admission.1.description': '経験豊富なスタッフが、あなたの目標やご経験に合わせた最適なコース選びをサポートします。',
  'coursesAdvanced.admission.2.titleEn': 'Apply',
  'coursesAdvanced.admission.2.title': 'お申込み',
  'coursesAdvanced.admission.2.description': 'コースが決まりましたら、所定の申込フォームよりお手続きください。定員になり次第締切となります。',
  'coursesAdvanced.admission.3.titleEn': 'Confirmation',
  'coursesAdvanced.admission.3.title': '受講確定',
  'coursesAdvanced.admission.3.description': 'お申込み受付後、受講確定のご案内と事前準備資料をお送りします。開校日をお待ちください。',

  // CTASection
  'coursesAdvanced.cta.label': 'TAKE THE FIRST STEP',
  'coursesAdvanced.cta.title': 'まずは資料請求から',
  'coursesAdvanced.cta.lead': '無料の資料でコースの詳細やアカデミーの理念をじっくりご確認いただけます。ご不明な点は個別相談（オンライン対応可）にてお気軽におたずねください。',
  'coursesAdvanced.cta.brochure': '資料請求はこちら（無料）',
  'coursesAdvanced.cta.consultation': '個別相談を予約する',
  'coursesAdvanced.cta.note': '※エッセンシャル修了者の編入優遇は申込時にお申し出ください',
  'coursesAdvanced.cta.seminarLink': '受講前に雰囲気を知りたい方は1日体験講座へ',

  // RelatedPages
  'coursesAdvanced.related.label': 'RELATED',
  'coursesAdvanced.related.title': '関連ページ',
  'coursesAdvanced.related.viewDetail': '詳しく見る',
  'coursesAdvanced.related.0.title': 'エッセンシャルコース',
  'coursesAdvanced.related.0.description': '基礎から始める入門課程',
  'coursesAdvanced.related.1.title': 'マスターコース',
  'coursesAdvanced.related.1.description': '管理と危機対応まで修める最上級課程',
  'coursesAdvanced.related.2.title': 'コース比較',
  'coursesAdvanced.related.2.description': '3コースの違いを一覧で確認',
  'coursesAdvanced.related.3.title': '年間スケジュール',
  'coursesAdvanced.related.3.description': '開校時期と授業日程のご案内',
  'coursesAdvanced.related.4.title': '料金詳細',
  'coursesAdvanced.related.4.description': '受講料に含まれるものの内訳',
  'coursesAdvanced.related.5.title': 'カリキュラム',
  'coursesAdvanced.related.5.description': '学ぶ内容の全体像を確認',

  // FAQSection
  'coursesAdvanced.faq.label': 'FAQ',
  'coursesAdvanced.faq.title': 'よくあるご質問',
  'coursesAdvanced.faq.0.question': 'エッセンシャルコースを受けずに直接申し込めますか？',
  'coursesAdvanced.faq.0.answer': 'はい、可能です。アドバンスコースはエッセンシャルの内容を含む課程のため、未経験の方も基礎から順に学べます。接客・サービスのご経験がある方はもちろん、経験不問でお申込みいただけます。なお、エッセンシャルコース修了者には重複内容分の編入優遇（受講料80,000円引き）もご用意しています。',
  'coursesAdvanced.faq.1.question': '特別実習（サービス体験）の費用は別途かかりますか？',
  'coursesAdvanced.faq.1.answer': '体験にかかる費用の詳細はお申込み時にご案内します。体験先までの交通費のみご負担ください。',
  'coursesAdvanced.faq.2.question': '仕事と両立できますか？',
  'coursesAdvanced.faq.2.answer': 'はい。授業は土日のみ・2ヶ月間（12日間）の設計ですので、お仕事を続けながらの受講を前提としています。',
  'coursesAdvanced.faq.3.question': '支払い方法を教えてください。',
  'coursesAdvanced.faq.3.answer': '銀行振込による一括払いのみとなります。分割払い・クレジットカードはご利用いただけません。お支払い期限は開校日の14日前です。',
};

export default coursesAdvanced;
